module.exports = __webpack_public_path__ + "img/hand.30220b75.png";